module.exports = __webpack_public_path__ + "assets/img/pt-ed8f2735.png";